import React, { useState,useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
// import Feedback from "react-bootstrap/esm/Feedback";
import {Feedback} from "../../../redux/actions/AuthAction"
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
function FeedbackComp(props) {

    const User = useSelector((state) => state.UserReducer.user);

    const [openSnackbar, closeSnackbar] = useSnackbar();
    const dispatch = useDispatch();
    const [rating,setRating] = useState("")
    const [feedback,setFeedback] = useState("")
    const [loder, setLoder] = useState(false);

    const submitFeedback = (e) =>{
        e.preventDefault();
        
        setLoder(true)

        if(!feedback && !rating){
          openSnackbar("Please fill all fields");
          setLoder(false);
        }
        else if(rating>5 || rating<1){
          openSnackbar("Please enter a valid rating");
          setLoder(false);
        }
        else{
        const data = {
          userID:User._id,
          userfeedback:feedback,
          rating:rating.toString()
        }
        const onSuccess = () =>{
          props.onHide()
          openSnackbar("Feedback submited successfully");
          setLoder(false)
        }
        const onError = () =>{
          props.onHide()
          openSnackbar("Somthing went wrong !!");
          setLoder(false)
        }
        dispatch(Feedback(data,onSuccess,onError))
      }
      }

  return (
    <div className="learner_account ">
      
          <h4>Feedback</h4>
          <Form onSubmit={(e)=>submitFeedback(e)}>
            <Form.Group controlId="formBasicPassword">
              <Form.Control
                className="input mt-3"
                type="number"
                placeholder="Rate clapingo out of 5"
                value={rating}
                onChange={(e)=>setRating(e.target.value)}
              />
              <Form.Control
                className="input feed"
                type="text"
                placeholder="Enter feedback"
                value={feedback}
                onChange={(e)=>setFeedback(e.target.value)}
                required
              />
            </Form.Group>

            <button className="feed-btn" type="submit" disabled={loder}> {loder?"Submiting..":"Submit"} </button>
          </Form>
        
    </div>
  );
}

export default FeedbackComp;
